import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './BusinessViewAll.css';
import locationnew from '../../../assets/images/icons/locationnew.svg'
import Breadcremb from '../../../components/BreadCremb';
import i18next from 'i18next';
class BusinessViewAll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            businesses: [],
            loading: true, // to track the loading state
            error: null, // to handle errors
        };
    }

    componentDidMount() {
        // Make an API call to fetch business data
        fetch(`${process.env.REACT_APP_BASE_URL}/web/api/v1/business-sale/viewall`)
            .then((response) => {
                console.log('Response:', response);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((response) => {
                // Check if the API returns the expected status code
                if (response.status_code === 200) {
                    // Set the fetched data to state
                    this.setState({
                        businesses: response.business_for_sale, // Adjusted based on API response
                        loading: false,
                    });
                } else {
                    // Handle cases where API status code is not 200
                    this.setState({
                        loading: false,
                        error: response.message || 'Failed to fetch business data',
                    });
                }
            })
            .catch((error) => {
                // Handle any network or other errors
                console.error('There was an error fetching the business data:', error);
                this.setState({
                    loading: false,
                    error: error.message,
                });
            });
    }

    render() {
        const { businesses, loading, error } = this.state;

        return (
            <div className='container'>
                <div className='breadcrumbs_Div'>
                    <div>
                        <Breadcremb flag="others" bredcrumb1_link="/tasker" bredcrumb1="Home" bredcrumb2="Details Page" />
                        <h1>{i18next.t('Business For Sale')}</h1>

                    </div>
                </div>
                <div className="business-grid">
                    {businesses.map((business, index) => {
                        if (index < 20) { // Limit to 20 items
                            return (
                                <div key={business.bookingId} className="business-item">
                                    <Link to={`/user/business-view/${business.bookingId}`}>
                                        <div className="business-content mx-1 business_right">
                                            <div className="categoryImg businesscat_img">
                                                <img
                                                    className="imgBg"
                                                    src={`https://emprende.net/public/img/bookings/${business.images[0]}`}
                                                    // src={`http://services.hitasoft.in/juan/public/img/bookings/${business.images[0]}`}
                                                    alt="Business Image"
                                                    height={135}
                                                />


                                            </div>

                                            <div className='business_wholecontent'>
                                                <div>
                                                    <h4 className="category-name" >{business.mainCategory.name}</h4>
                                                    <p className="subcategory-name">{business.subCategory.name}</p>
                                                </div>
                                                <h3 className="price">USD{Math.floor(business.new_price)?.toLocaleString('en-US')}</h3>
                                            </div>
                                            <div className='business_location'>
                                                <img src={locationnew} />
                                                <p className="city-name">{business.city}</p>
                                                , <p className="city-name">{business.country}</p>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        );
    }
}

export default BusinessViewAll;
